import PicPutRequest from '../PicPutRequest';
import { prtErr } from '../../utils/prt';

/* Note, the payload itself has the parms need to make the api call  */
const updateParticipantAttendance = (event_id, participantEmail, rsvpFlag, token) => {

     /* Construct request body for update attendance */
     let reqObject = {
        event_id,
        participantEmail,
        attend: rsvpFlag === "yes" ? "y" : "n"
    }

    let apiPromise  = new Promise (function resolver(resolve, reject) {   
        let putRequest = new PicPutRequest("updateParticipantAttenance");
        putRequest
            .setUserId(participantEmail)
            .setUri('/event/invite/participant/attendance')
            .setRequestBody(reqObject)
            .setAuthToken(token)                       
            .setLogTrace(false);
            putRequest.exec().then((response) => {
            resolve(response)
        }).catch((err) => {
            let error = putRequest.getError(); /* print notification below but propagate actual error via reject for debugging purposes */
            prtErr(`Error: encountered with the addNewParticipant api while trying to add participant:${participantEmail} for event_id:${event_id} `);
            reject(error)
        }); /* end Promise */
    })
    return apiPromise;
}

export default updateParticipantAttendance


// WEBPACK FOOTER //
// ./src/apis/participant/updateParticipantAttendance.js